import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { QuieroAyudaComponent } from '../quiero-ayuden/quiero-ayuden.component';
import { DatosComercioServiceVM } from 'src/app/view-model/services/datos-comercio.service';
import { Paso1 } from 'src/app/global/interfaces/paso-1';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { LlamarCliente } from 'src/app/global/interfaces/datos-comercio';
import { Paso2 } from 'src/app/global/interfaces/paso-2';
import { IdentificacionComercioResponse } from 'src/app/global/interfaces/identificacion-comercio-response';
import { environment } from 'src/environments/environment';
import { GoogleTagManager } from 'src/app/global/providers/services/tag-manager/models/tag-manager.models';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';

@Component({
  selector: 'app-sin-actividad',
  templateUrl: './sin-actividad.component.html',
  styleUrls: ['./sin-actividad.component.scss']
})
export class SinActividadComponent implements OnInit {
  @ViewChild('noActividadModal', { static: false }) noActividadModal!: ElementRef;
  public modalRef: NgbModalRef | null = null;

  paso1: Paso1;
  paso2: Paso2;
  runLogin = '';
  nombreLogin = '';
  razonSocial = '';

  constructor(
    private modalService: NgbModal,
    private datosComercioServ: DatosComercioServiceVM,
    private storage: LocalStorageService,
    private tagM: TagManagerService
  ) {}

  ngOnInit(): void {
    this.paso1 = this.storage.getPaso1();
    this.paso2 = this.storage.getPaso2();
    this.runLogin = this.paso1 && this.paso1.run ? this.paso1.run.toString() : '';
    this.tagM.logEvent(GoogleTagManager.eventPageView().sinActividadEconomica());

    const nombres =
      this.paso2 &&
      this.paso2.datosPersonales &&
      this.paso2.datosPersonales.nombres &&
      this.paso2.datosPersonales.nombres.nombres;

    const razonSocialLocal =
      this.paso2 &&
      this.paso2.datosComercio &&
      this.paso2.datosComercio.razonSocial;

    this.razonSocial = razonSocialLocal || '';
    this.nombreLogin = nombres || this.razonSocial || '';
  }

  abrirModal() {
    if (this.noActividadModal) {
      this.modalRef = this.modalService.open(this.noActividadModal, { centered: true, backdrop: 'static', keyboard: false });
    }
  }

  private formatRun(run: string): string {
    const runSinFormato = run.replace(/\./g, '');
    return runSinFormato.includes('-')
      ? runSinFormato.replace(/-.*$/, '')
      : (runSinFormato.length === 9 ? runSinFormato.slice(0, -1) : runSinFormato);
  }
  
  goToAyuda(): void {
    location.href = environment.redirections.ayudatransbank;
  }
  
  cerrarYAbrirOtro() {
    if (!this.modalRef) {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      this.modalRef = null; 
      this.modalService.dismissAll();
      const runFormateado = this.formatRun(this.runLogin);
      const clienteData: LlamarCliente = { run: runFormateado, llamar: true };
      this.tagM.logEvent(GoogleTagManager.eventInteracciones().sinActividadEconomica().accionClick().setEtiqueta("quiero que me ayuden"))
      this.datosComercioServ.llamarCliente(clienteData).subscribe({
        next: () => {
          this.modalRef = this.modalService.open(QuieroAyudaComponent, { centered: true, backdrop: 'static', keyboard: false });
        },
        error: (error) => {
          console.error('Error al llamar al cliente:', error);
        }
      });
    }
  }
  
}
